"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Participant = void 0;
const constants_1 = require("../../constants");
const device_profile_1 = require("./device.profile");
const property_1 = require("../../decorators/property");
const mocks_1 = require("../../mocks");
class Participant {
}
exports.Participant = Participant;
__decorate([
    (0, property_1.Property)({ type: mocks_1.ObjectId, index: true }),
    __metadata("design:type", String)
], Participant.prototype, "id", void 0);
__decorate([
    (0, property_1.Property)(),
    __metadata("design:type", String)
], Participant.prototype, "name", void 0);
__decorate([
    (0, property_1.Property)({ type: String, enum: constants_1.UserTypeEnum }),
    __metadata("design:type", String)
], Participant.prototype, "userType", void 0);
__decorate([
    (0, property_1.Property)({ type: () => device_profile_1.DeviceProfile }),
    __metadata("design:type", device_profile_1.DeviceProfile)
], Participant.prototype, "deviceProfile", void 0);
